<template>
  <Form
    :form-id="formId"
    :initial-values="initialValues"
    action="#"
    :class="{ dirty }"
  >
    <HiddenInput input-id="id" />

    <VPInput
      ref="nameRef"
      :disabled="disabled"
      input-id="name"
      placeholder="Add Member"
    />
    <VPInput
      ref="emailRef"
      :disabled="disabled"
      input-id="email"
      placeholder="Add Email"
    />
    <VPInput
      ref="roleRef"
      :disabled="disabled"
      input-id="role"
      placeholder="Add Role"
    />
  </Form>
</template>

<script setup lang="ts">
import { Form, HiddenInput, useFormsStore } from 'vuniform';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import VPInput from '@/components/form/VPInput.vue';

const nameRef = ref<VPInput>(null);
const roleRef = ref<VPInput>(null);
const emailRef = ref<VPInput>(null);

const formsStore = useFormsStore();

interface Props {
  formId: string;
  initialValues: unknown;
  disabled?: boolean;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'blur'): void;
  (e: 'save'): void;
  (e: 'clear'): void;
}>();

const refs = [nameRef, roleRef, emailRef];

const activeElement = ref<EventTarget | null>(null);

const focusChanged = (e: Event) => {
  activeElement.value = e.target;
};

onMounted(() => {
  document.addEventListener('focusin', focusChanged);
});
onBeforeUnmount(() => {
  document.removeEventListener('focusin', focusChanged);
});

const hasFocus = computed(() =>
  refs.some(r => r.value?.inputRef && activeElement.value && r.value?.inputRef === activeElement.value),
);

const hasValue = computed(() => {
  return ['name', 'role', 'email'].some(f => formsStore.fieldGetValue(props.formId, f));
});

watch(hasFocus, (newValue, oldValue) => {
  if (oldValue && !newValue) {
    if (hasValue.value) {
      emit('blur');
    } else {
      emit('clear');
    }
  }
});

const dirty = computed(() => formsStore.isFormDirty(props.formId));
</script>
